<template>
  <v-card flat style="background-color:#e9e9e9;">
   
    <v-tabs  fixed-tabs elevation-0  style="background-color:#e9e9e9;">
      <v-tab @change="changetab('Role Master')">
        <v-icon left>
          mdi-bank
        </v-icon>
        Role Master
      </v-tab>

 <v-tab @change="changetab('Event + Role - Mapping')">
        <v-icon left>
          mdi-account-network
        </v-icon>
       Event + Role Mapping
      </v-tab>


       <v-tab @change="changetab('Role Stand Mapping')">
        <v-icon left>
          mdi-account-network
        </v-icon>
       Role Stand Mapping
      </v-tab>

      <v-tab-item >
        <mediarole></mediarole>
      </v-tab-item>
     
     
       <v-tab-item style="background-color:#e9e9e9;">
       <Eventstatusmerge></Eventstatusmerge>
      </v-tab-item>


        <v-tab-item style="background-color:#e9e9e9;">
       <MediaJobstandmap></MediaJobstandmap>
      </v-tab-item>
    



     
      
    </v-tabs>
  </v-card>
</template>
<script>
import mediarole from '../../../components/mediarole'
import Eventstatusmerge from '../../../components/EventMediarRolemerge.vue'
import MediaJobstandmap from '../masters/MediaJobstandmap.vue'
export default {
 components: {mediarole,Eventstatusmerge,MediaJobstandmap},
  methods:{
    changetab: function(pagename) {
        this.$store.commit("setPageTitle", pagename);
    }
 }
  
}
</script>